import {View} from "./view.mjs";
import main1Template from "../templates/main1.njk";
import {plannerViewProvider} from "./planner.view.mjs";


export function main1ViewProvider(){


    class Main1View extends View{
        constructor(){
            super();
            var _plannerView = plannerViewProvider();

            var _id = 'main';   // should be a unique id ?
            var _blockHeaderMacroName = 'displayblockHeader1'; // name of the macro
            var _height;
            var _hasBlockHeader = true;

            Object.defineProperty(this,'id',{
                set : function(id){ _id = id },
                get : function(){ return _id }
            })

            Object.defineProperty(this,'blockHeaderMacroName',{
                set : function(n){ _blockHeaderMacroName = n },
                get :function(){ return _blockHeaderMacroName }
            })

            Object.defineProperty(this,'plannerView',{
                get : function(){ return _plannerView }
            });



            Object.defineProperty(this,'height',{
                set : function(h){ _height = h },
                get : function(){ return _height }
            })

            Object.defineProperty(this,'hasBlockHeader',{
                set : function(b){ _hasBlockHeader = b },
                get : function(){ return _hasBlockHeader }
            })
        }

        getContext(){
            var context = {
                id : this.id,
                blockHeaderMacroName : this.blockHeaderMacroName,
                blockHeaderTitleUrl: '', // TMP 
                title : 'Planner',  // TMP 
                height : this.getHeight(),
                hasBlockHeader : this.hasBlockHeader,
            }
            return context;
        }

        getTemplate(){
            return main1Template;
        }

        getPlannerView(){ return this.plannerView }


        getDomId(){
            return `#${this.id}`;
        }

        getHeight(){ return this.height }

        initView(){
            var selector = this.getDomId() + ' .block-content';
            var document = this.getDocument();
            this.getPlannerView().insertView(document,selector);
            //this.alertListView.insertView(document, selector);
        }

        setHeight(height){
           this.height = height; 
        }

        setBlockHeaderName(name){
            this.blockHeaderMacroName = name;
        }

        setNoBlockHeader(){
            this.hasBlockHeader = false; 
            
        }



        

        
    }

    return new Main1View();
}